import InlineLoadingSpinner from './InlineLoadingSpinner';

export default function Button({type = 'button', loading = false, children, ...props}) {
    const classList = props.className ? props.className.split(' ') : undefined;
    const showDarkSpinner = classList && (classList.includes('btn-default') || classList.includes('btn-default-clear') || classList.includes('btn-link'));

    return <button type={type} disabled={loading} {...props}>
        {loading ? <InlineLoadingSpinner type={showDarkSpinner ? 'dark' : 'light'}/> : null}
        {children}
    </button>;
}
